/*** IMPORTS FROM imports-loader ***/
var define = false;

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
require('./_set-collection-from')('WeakMap');

